function isOnLastBlock(value) {
  var document = value.document,
      selection = value.selection;
  var lastKey = document.getBlocks().last().nodes.last().key;
  return selection.focus.key === lastKey || selection.anchor.key === lastKey;
}

export default isOnLastBlock;